module.exports = __webpack_public_path__ + "img/boxplot_illustration.svg";